export default __webpack_public_path__ + "static/media/10_Business-ProductArchitecture-InteriorEschweilerPhotography_M1A7563_2.a8f4785c.jpg";